import { useEffect, useRef } from 'react';

import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import PostTag from '../components/PostTag';

import Search from './search';

import './TagPopup.css';

export default function TagPopup({ 
  open, 
  close, 
  addTag, 
  removeTag, 
  formState, 
  contentEditableRef, 
  setFormState 
}) {

  // ① create a ref for the search input
  const inputRef = useRef(null);

  // ② whenever the popup opens, focus the input
  useEffect(() => {
    if (open) {
      // timeout to wait until the sheet is in the DOM
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [open]);

  // New simplified handleSelectTag function using string replacement.
  const handleSelectTag = (tag) => {
    // Update the form state with the new tag
    addTag(tag);
    // Ensure we have the editor reference and setFormState to update
    if (contentEditableRef && contentEditableRef.current && setFormState) {
      // TODO: reimplement tags
    }
    close();
  };

  return (
    <>
      <PopupToBottomSheet 
        open={open} 
        close={close} 
        popupOptions={{ opacity: true }}
      >
        <div className="post-tags__container">
          <div className="post-tags__header">
            <Text className="post-tags__header-text font-size-medium">
              Add tag
            </Text>
            <XIcon className="post-tags__close-button" onClick={close}/>
          </div>
          {/* Pass the simplified handleSelectTag to Search */}
          <Search addTag={handleSelectTag} formState={formState}/>
          <div className="post-tags__tags remove-scrollbar">
            {formState.post_tags.map(tag => (
              <PostTag 
                key={tag._id}
                tag={tag}  
                removeTag={removeTag} 
              />
            ))}
          </div>
        </div>
      </PopupToBottomSheet>
    </>
  );
}
